import { Injectable } from "@angular/core";
// import { ShopDataState } from 'src/app/component/e-commerce/shop/shop.component';

@Injectable({
  providedIn: "root",
})
export class ShopService {
  constructor() {}

  allData = [
    {
      id: "1",
      name: "Candy Pure Rose Water",
      offer_price: "$16,599",
      photo: "./assets/images/pngs/9.jpg",
      price: "$19,799",
      Quantity: 1,
    },
  ];

  gettingData(data: any) {
    this.allData.push(...data);
    return data;
  }

  retunData() {
    return this.allData;
  }

  addingQuantity(id: any) {
    this.allData[0].Quantity++;
  }

  decreaseQuantity(id: any) {
    if (this.allData[0].Quantity > 0) {
      this.allData[0].Quantity--;
    }
  }

  delectItem(id: any) {
    var data = this.allData.filter((x) => {
      return x.id != id;
    });
    this.allData = data;
  }

  // getPosta(){
  //   const DATA: ShopDataState[] = [ {
  //     id:"1",
  //     photo: './assets/images/pngs/9.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/9.jpg'},
  //       {'img': './assets/images/pngs/9-2.png'},
  //       {'img': './assets/images/pngs/9-3.png'},
  //       {'img': './assets/images/pngs/9-4.png'}
  //     ],
  //     name:"Candy Pure Rose Water",
  //     offer_price: 6599,
  //     price: 1799,
  //     Quantity: 1,
  //   }, {
  //     id:"2",
  //     photo: './assets/images/pngs/10.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/10.jpg'},
  //       {'img': './assets/images/pngs/10-2.png'},
  //       {'img': './assets/images/pngs/10-3.png'},
  //       {'img': './assets/images/pngs/10-4.png'}
  //     ],
  //     name:"White Tshirt For Men",
  //     offer_price: 14599,
  //     price: 14799,
  //     Quantity: 1,
  //   }, {
  //     id:"3",
  //     photo: './assets/images/pngs/4.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/4.jpg'},
  //       {'img': './assets/images/pngs/4-2.png'},
  //       {'img': './assets/images/pngs/4-3.png'},
  //       {'img': './assets/images/pngs/4-4.png'}
  //     ],
  //     name:"Flower Pot For Home Decor",
  //     offer_price: 18599,
  //     price: 19799,
  //     Quantity: 1,
  //   }, {
  //     id:"4",
  //     photo: './assets/images/pngs/8.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/8.jpg'},
  //       {'img': './assets/images/pngs/8-2.png'},
  //       {'img': './assets/images/pngs/8-3.png'},
  //       {'img': './assets/images/pngs/8-4.png'}
  //     ],
  //     name:"Stylish Rockerz 255 Ear Pods",
  //     offer_price: 76599,
  //     price: 19799,
  //     Quantity: 1,
  //   }, {
  //     id:"5",
  //     photo: './assets/images/pngs/1.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/1.jpg'},
  //       {'img': './assets/images/pngs/1-2.png'},
  //       {'img': './assets/images/pngs/1-3.png'},
  //       {'img': './assets/images/pngs/1-4.png'}
  //     ],
  //     name:"Women Party Wear Dress",
  //     offer_price: 7599,
  //     price: 19799,
  //     Quantity: 1,
  //   }, {
  //     id:"6",
  //     photo: './assets/images/pngs/6.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/6.jpg'},
  //       {'img': './assets/images/pngs/6-2.png'},
  //       {'img': './assets/images/pngs/6-3.png'},
  //       {'img': './assets/images/pngs/6-4.png'}
  //     ],
  //     name:"Black Digital Camera",
  //     offer_price: 18579,
  //     price: 19799,
  //     Quantity: 1,
  //   }, {
  //     id:"7",
  //     photo: './assets/images/pngs/5.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/5.jpg'},
  //       {'img': './assets/images/pngs/5-2.png'},
  //       {'img': './assets/images/pngs/5-3.png'},
  //       {'img': './assets/images/pngs/5-4.png'}
  //     ],
  //     name:"Men Shirt For Party Wear",
  //     offer_price: 5599,
  //     price: 19799,
  //     Quantity: 1,
  //   }, {
  //     id:"8",
  //     photo: './assets/images/pngs/7.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/7.jpg'},
  //       {'img': './assets/images/pngs/7-1.jpg'},
  //       {'img': './assets/images/pngs/7-2.jpg'},
  //       {'img': './assets/images/pngs/7-3.jpg'}
  //     ],
  //     name:"Light Pink Nail Polish",
  //     offer_price: 18559,
  //     price: 19799,
  //     Quantity: 1,
  //   }, {
  //     id:"9",
  //     photo: './assets/images/pngs/3.jpg',
  //     children: [
  //       {'img': './assets/images/pngs/3.jpg'},
  //       {'img': './assets/images/pngs/3-2.jpg'},
  //       {'img': './assets/images/pngs/3-3.jpg'},
  //       {'img': './assets/images/pngs/3-4.png'}
  //     ],
  //     name:"Running Shoes For Men",
  //     offer_price: 1299,
  //     price: 19799,
  //     Quantity: 1,
  //   }
  //   ];
  //   return DATA
  // }
}
